import React from "react";
import { Helmet } from "react-helmet-async";
import asheshImage from "../img/ashesh.jpg";
import sahastranshuImage from "../img/sahastranshu.jpg";

class About extends React.Component {
  constructor() {
    super();
    this.state = {
      about_us: {
        title: "Who We Are",
        overview:
          "Ethervue is a trusted leader in delivering innovative and sustainable solutions across Information Technology, Decision Science, Management, GIS, and Participatory Irrigation Management.",
      },
      leadership: [
        {
          name: "Ashesh Sinha",
          position: "Managing Director",
          image: asheshImage,
          bio: [
            "With over 30 years of experience at the intersection of technology, data, and development, Ashesh Sinha brings a wealth of expertise in Information Technology, Monitoring & Evaluation (M&E), Statistical Analysis, Participatory Irrigation Management(PIM) and Geographical Information System(GIS). A seasoned leader in the Social Development sector, Ashesh has spearheaded World Bank-funded initiatives for more than two decades, shaping impactful change through innovative solutions.",
            "A triple powerhouse with an M.Sc. in Statistics from Banaras Hindu University (BHU),  an MBA in Marketing from IGNOU, and Honors Diploma in Systems Management from NIIT, Ashesh is also proficient in Artificial Intelligence, Machine Learning, Data Science, Full Stack Development and advanced programming languages like C, Python, Java, VBA, Tensor Flow and PyTorch. His experience spans both urban and rural development projects, with a unique blend of technical and management expertise in application software, RDBMS, and GIS.",
            "Known for exceptional leadership, communication, and analytical skills, Ashesh is committed to driving excellence and growth at Ethervue—empowering organisations with cutting-edge technology and data-driven insights to unlock their full potential."
          ],
        },
        {
          name: "Sahastranshu Sinha",
          position: "Executive Director",
          image: sahastranshuImage,
          bio: [
            "A dynamic and innovative technology leader, Sahastranshu Sinha is an MCA Silver Medalist and BCA Gold Medalist from Amity University, with a passion for driving excellence in machine learning, artificial intelligence, and full-stack development. With an exceptional academic track record, including the prestigious Bank of Baroda Award for Best in Academics and the Baljeet Shastri Award for Human Values, Sahastranshu combines technical brilliance with a strong commitment to ethical leadership.",
            "Equipped with hands-on experience in Python (OpenCV, TensorFlow, PyTorch), advanced Java programming, data science, and mobile application development, Sahastranshu is a versatile professional who excels in cutting-edge technologies and development frameworks. A master in RDBMS, UI/UX design (Figma), and web and mobile app development, he’s also an expert in building scalable, data-driven solutions.",
            "With a unique blend of technical expertise and strong interpersonal skills, Sahastranshu is driving strategic initiatives at Ethervue—empowering organizations to thrive in a technology-driven world while fostering innovation and value at every step."
          ],
        },
      ],
    };
  }

  render() {
    return (
      <section id="about" className="about-mf sect-pt4 route">
        <Helmet>
          <title>About Us - Ethervue</title>
          <meta name="description" content="Learn more about Ethervue, a leader in IT, Decision Science, GIS, and Participatory Irrigation Management." />
          <meta name="keywords" content="Ethervue, IT Solutions, Decision Science, GIS, Irrigation Management, Leadership Team" />
          <meta name="author" content="Ethervue" />
        </Helmet>

        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div className="box-shadow-full">
                <div className="about-me pt-4 pt-md-0">
                  <div className="title-box-2">
                    <h5 className="title-center">{this.state.about_us.title}</h5>
                  </div>
                  <p className="lead">{this.state.about_us.overview}</p>
                </div>
                <div className="title-box-2 mt-4">
                  <h5 className="title-left">Leadership</h5>
                </div>
                {this.state.leadership.map((director, index) => (
                  <div key={index}>
                    <div className="title-box-2 mt-4">
                      <h5 className="title-left" style={{ fontSize: "1.5rem", fontWeight: "bold" }}>{director.position}</h5>
                      <hr />
                    </div>
                    <div className="row mt-4">
                      <div className="col-md-3 text-center">
                        <img
                          src={director.image}
                          alt={director.name}
                          className="img-fluid rounded b-shadow-a"
                        />
                      </div>
                      <div className="col-md-9">
                        <h5 style={{ fontSize: "1.5rem" }}>{director.name}</h5>
                        <h6></h6>
                        {director.bio.map((paragraph, i) => (
                          <p key={i} style={{ marginBottom: "1rem" }}>{paragraph}</p>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default About;
